import { ToastContainer as OriginalToastContainer, toast as showToast, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
const toast = ({ icon, type = 'default', text, position = 'bottom-center', autoClose = 3000, hideProgressBar = true, closeOnClick = false, pauseOnHover = false, draggable = false, }) => {
    showToast(text, {
        icon: icon,
        type: type,
        position: position,
        autoClose: autoClose,
        hideProgressBar: hideProgressBar,
        closeOnClick: closeOnClick,
        pauseOnHover: pauseOnHover,
        draggable: draggable,
        closeButton: false,
    });
};
const ToastContainer = styled(OriginalToastContainer) `
  .Toastify__toast {
    border-radius: 5px;
    font-family: 'Ubuntu';
  }
  .Toastify__toast-theme--colored {
    background: #4B4B4B;
  }

  .Toastify__toast-theme--colored.Toastify__toast--default {
    color: #fff;
  }

  @media only screen and (max-width : 480px) {
  .Toastify__toast {
    border-radius: 0;
  }
}
`;
export { ToastContainer, toast };
//# sourceMappingURL=Toast.js.map